export const getStoredCustomerId = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem('myUser');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.customer_id || null;
  } catch {
    return null;
  }
};

export default getStoredCustomerId;
